module.exports = __webpack_public_path__ + "img/30b0cd257c16f74d21b795f8a9a1b77c.jpg";